import { render, staticRenderFns } from "./LinkedObjectCard.vue?vue&type=template&id=73f5732e&"
import script from "./LinkedObjectCard.vue?vue&type=script&lang=js&"
export * from "./LinkedObjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports